import { render, staticRenderFns } from "./WsNotifications.vue?vue&type=template&id=74714dd9"
import script from "./WsNotifications.vue?vue&type=script&lang=js"
export * from "./WsNotifications.vue?vue&type=script&lang=js"
import style0 from "./WsNotifications.vue?vue&type=style&index=0&id=74714dd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports